// Training Plans Data
// This file contains all the training plan definitions and schedules

export const trainingPlans = [
    {
      id: 1,
      name: "5K Build",
      desc: "8-week plan for 5K improvement",
      weeks: [15, 18, 20, 22, 20, 24, 15, 12],
      diff: "Beginner",
      runs: 4,
      goal: "race",
      raceType: "5K"
    },
    {
      id: 2,
      name: "Half Marathon Base",
      desc: "12-week half marathon preparation",
      weeks: [20, 22, 25, 28, 30, 32, 28, 35, 32, 38, 25, 13],
      diff: "Intermediate",
      runs: 5,
      goal: "race",
      raceType: "Half Marathon"
    },
    {
      id: 3,
      name: "Marathon Training",
      desc: "16-week marathon build",
      weeks: [25, 28, 32, 35, 40, 45, 35, 50, 45, 55, 50, 60, 45, 35, 20, 13],
      diff: "Advanced",
      runs: 6,
      goal: "race",
      raceType: "Marathon"
    },
    {
      id: 4,
      name: "Couch to 5K",
      desc: "9-week beginner program to run your first 5K",
      weeks: [6, 8, 9, 10, 11, 13, 14, 15, 16],
      diff: "Beginner",
      runs: 3,
      goal: "start",
      isTimeBasedPlan: true
    },
    {
      id: 5,
      name: "Base Building",
      desc: "6-week maintenance plan to keep fitness",
      weeks: [20, 20, 22, 22, 20, 20],
      diff: "All Levels",
      runs: 4,
      goal: "maintain"
    },
    {
      id: 6,
      name: "10K Training",
      desc: "10-week plan for 10K racing",
      weeks: [18, 20, 22, 24, 26, 24, 28, 26, 20, 12],
      diff: "Intermediate",
      runs: 4,
      goal: "race",
      raceType: "10K"
    },
    {
      id: 7,
      name: "Hal Higdon Intermediate 1",
      desc: "18-week marathon plan for runners with base fitness",
      weeks: [16, 16, 16, 18, 18, 17, 22, 22, 13, 24, 26, 23, 23, 23, 23, 20, 16, 9],
      diff: "Intermediate",
      runs: 5,
      goal: "race",
      raceType: "Marathon"
    }
  ];
  
  // Couch to 5K Detailed Schedule
  // Based on a standard 9-week Couch to 5K program
  // Note: Warm-up (5 min brisk walk) and cool-down (5 min walk) included in all workouts
  export const couchTo5KSchedule = [
    // Week 1 - Days 1, 3, 5
    {
      day: 1,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 1 min, Walk 90 sec (repeat 6 times). Walk 5 min to cool down.',
      timeFormat: '1m/90s ×6',
      timeFormatLong: 'run 1min / walk 90sec × 6',
      distance: 1.5
    },
    {
      day: 3,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 1 min, Walk 90 sec (repeat 6 times). Walk 5 min to cool down.',
      timeFormat: '1m/90s ×6',
      timeFormatLong: 'run 1min / walk 90sec × 6',
      distance: 1.5
    },
    {
      day: 5,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 1 min, Walk 90 sec (repeat 6 times). Walk 5 min to cool down.',
      timeFormat: '1m/90s ×6',
      timeFormatLong: 'run 1min / walk 90sec × 6',
      distance: 1.5
    },

    // Week 2 - Days 8, 10, 12
    {
      day: 8,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 90 sec, Walk 2 min (repeat 5 times). Walk 5 min to cool down.',
      timeFormat: '90s/2m ×5',
      timeFormatLong: 'run 90sec / walk 2min × 5',
      distance: 1.7
    },
    {
      day: 10,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 90 sec, Walk 2 min (repeat 5 times). Walk 5 min to cool down.',
      timeFormat: '90s/2m ×5',
      timeFormatLong: 'run 90sec / walk 2min × 5',
      distance: 1.7
    },
    {
      day: 12,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 90 sec, Walk 2 min (repeat 5 times). Walk 5 min to cool down.',
      timeFormat: '90s/2m ×5',
      timeFormatLong: 'run 90sec / walk 2min × 5',
      distance: 1.7
    },

    // Week 3 - Days 15, 17, 19
    {
      day: 15,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 90 sec, Walk 90 sec, Run 3 min, Walk 3 min (repeat 2 times). Walk 5 min to cool down.',
      timeFormat: '90s/90s, 3m/3m ×2',
      timeFormatLong: 'run 90sec / walk 90sec, run 3min / walk 3min × 2',
      distance: 2.0
    },
    {
      day: 17,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 90 sec, Walk 90 sec, Run 3 min, Walk 3 min (repeat 2 times). Walk 5 min to cool down.',
      timeFormat: '90s/90s, 3m/3m ×2',
      timeFormatLong: 'run 90sec / walk 90sec, run 3min / walk 3min × 2',
      distance: 2.0
    },
    {
      day: 19,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 90 sec, Walk 90 sec, Run 3 min, Walk 3 min (repeat 2 times). Walk 5 min to cool down.',
      timeFormat: '90s/90s, 3m/3m ×2',
      timeFormatLong: 'run 90sec / walk 90sec, run 3min / walk 3min × 2',
      distance: 2.0
    },

    // Week 4 - Days 22, 24, 26
    {
      day: 22,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 3 min, Walk 90 sec, Run 5 min, Walk 2½ min, Run 3 min, Walk 90 sec, Run 5 mins. Walk 5 min to cool down.',
      timeFormat: '3m/90s, 5m/2.5m ×2',
      timeFormatLong: 'run 3min / walk 90sec, run 5min / walk 2.5min × 2',
      distance: 2.3
    },
    {
      day: 24,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 3 min, Walk 90 sec, Run 5 min, Walk 2½ min, Run 3 min, Walk 90 sec, Run 5 mins. Walk 5 min to cool down.',
      timeFormat: '3m/90s, 5m/2.5m ×2',
      timeFormatLong: 'run 3min / walk 90sec, run 5min / walk 2.5min × 2',
      distance: 2.3
    },
    {
      day: 26,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 3 min, Walk 90 sec, Run 5 min, Walk 2½ min, Run 3 min, Walk 90 sec, Run 5 mins. Walk 5 min to cool down.',
      timeFormat: '3m/90s, 5m/2.5m ×2',
      timeFormatLong: 'run 3min / walk 90sec, run 5min / walk 2.5min × 2',
      distance: 2.3
    },

    // Week 5 - Days 29, 31, 33
    {
      day: 29,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 5 min, Walk 3 min, Run 5 min, Walk 3 min, Run 5 min. Walk 5 min to cool down.',
      timeFormat: '5m/3m ×3',
      timeFormatLong: 'run 5min / walk 3min × 3',
      distance: 2.5
    },
    {
      day: 31,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 8 min, Walk 5 min, Run 8 min. Walk 5 min to cool down.',
      timeFormat: '8m/5m, 8m',
      timeFormatLong: 'run 8min / walk 5min, run 8min',
      distance: 2.5
    },
    {
      day: 33,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 5 min, Walk 3 min, Run 5 min, Walk 3 min, Run 5 min. Walk 5 min to cool down.',
      timeFormat: '5m/3m ×3',
      timeFormatLong: 'run 5min / walk 3min × 3',
      distance: 2.5
    },

    // Week 6 - Days 36, 38, 40
    {
      day: 36,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 5 min, Walk 3 min, Run 8 min, Walk 3 min, Run 5 min. Walk 5 min to cool down.',
      timeFormat: '5m/3m, 8m/3m, 5m',
      timeFormatLong: 'run 5min / walk 3min, run 8min / walk 3min, run 5min',
      distance: 2.7
    },
    {
      day: 38,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 10 min, Walk 3 min, Run 10 min. Walk 5 min to cool down.',
      timeFormat: '10m/3m, 10m',
      timeFormatLong: 'run 10min / walk 3min, run 10min',
      distance: 2.8
    },
    {
      day: 40,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 5 min, Walk 3 min, Run 8 min, Walk 3 min, Run 5 min. Walk 5 min to cool down.',
      timeFormat: '5m/3m, 8m/3m, 5m',
      timeFormatLong: 'run 5min / walk 3min, run 8min / walk 3min, run 5min',
      distance: 2.7
    },

    // Week 7 - Days 43, 45, 47
    {
      day: 43,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 25 min continuously. Walk 5 min to cool down.',
      timeFormat: '25m',
      timeFormatLong: 'run 25min',
      distance: 2.8
    },
    {
      day: 45,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 25 min continuously. Walk 5 min to cool down.',
      timeFormat: '25m',
      timeFormatLong: 'run 25min',
      distance: 2.8
    },
    {
      day: 47,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 25 min continuously. Walk 5 min to cool down.',
      timeFormat: '25m',
      timeFormatLong: 'run 25min',
      distance: 2.8
    },

    // Week 8 - Days 50, 52, 54
    {
      day: 50,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 28 min continuously. Walk 5 min to cool down.',
      timeFormat: '28m',
      timeFormatLong: 'run 28min',
      distance: 3.0
    },
    {
      day: 52,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 28 min continuously. Walk 5 min to cool down.',
      timeFormat: '28m',
      timeFormatLong: 'run 28min',
      distance: 3.0
    },
    {
      day: 54,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 28 min continuously. Walk 5 min to cool down.',
      timeFormat: '28m',
      timeFormatLong: 'run 28min',
      distance: 3.0
    },

    // Week 9 - Days 57, 59, 61
    {
      day: 57,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 30 min continuously. Walk 5 min to cool down.',
      timeFormat: '30m',
      timeFormatLong: 'run 30min',
      distance: 3.1
    },
    {
      day: 59,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 30 min continuously. Walk 5 min to cool down.',
      timeFormat: '30m',
      timeFormatLong: 'run 30min',
      distance: 3.1
    },
    {
      day: 61,
      type: 'easy',
      notes: '5 min brisk walk to warm up. Run 30 min or 5K continuously. Walk 5 min to cool down.',
      timeFormat: '30m',
      timeFormatLong: 'run 30min',
      distance: 3.1
    }
  ];

  // Hal Higdon Intermediate 1 Marathon Detailed Schedule
  // 18-week plan with cross-training, runs, and pace workouts
  // Days are numbered 1-126 (18 weeks × 7 days)
  export const halHigdonInt1Schedule = [
    // Week 1 (Days 1-7)
    { day: 1, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 2, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 3, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 4, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 6, type: 'workout', notes: '5 mi pace run', distance: 5 },
    { day: 7, type: 'long', notes: '8 mi long run', distance: 8 },

    // Week 2 (Days 8-14)
    { day: 8, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 9, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 10, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 11, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 13, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 14, type: 'long', notes: '9 mi long run', distance: 9 },

    // Week 3 (Days 15-21)
    { day: 15, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 16, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 17, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 18, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 20, type: 'workout', notes: '5 mi pace run', distance: 5 },
    { day: 21, type: 'long', notes: '6 mi long run', distance: 6 },

    // Week 4 (Days 22-28)
    { day: 22, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 23, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 24, type: 'easy', notes: '6 mi run', distance: 6 },
    { day: 25, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 27, type: 'workout', notes: '6 mi pace run', distance: 6 },
    { day: 28, type: 'long', notes: '11 mi long run', distance: 11 },

    // Week 5 (Days 29-35)
    { day: 29, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 30, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 31, type: 'easy', notes: '6 mi run', distance: 6 },
    { day: 32, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 34, type: 'easy', notes: '6 mi run', distance: 6 },
    { day: 35, type: 'long', notes: '12 mi long run', distance: 12 },

    // Week 6 (Days 36-42)
    { day: 36, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 37, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 38, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 39, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 41, type: 'workout', notes: '6 mi pace run', distance: 6 },
    { day: 42, type: 'long', notes: '9 mi long run', distance: 9 },

    // Week 7 (Days 43-49)
    { day: 43, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 44, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 45, type: 'easy', notes: '7 mi run', distance: 7 },
    { day: 46, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 48, type: 'workout', notes: '7 mi pace run', distance: 7 },
    { day: 49, type: 'long', notes: '14 mi long run', distance: 14 },

    // Week 8 (Days 50-56)
    { day: 50, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 51, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 52, type: 'easy', notes: '7 mi run', distance: 7 },
    { day: 53, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 55, type: 'easy', notes: '7 mi run', distance: 7 },
    { day: 56, type: 'long', notes: '15 mi long run', distance: 15 },

    // Week 9 - Race Week (Days 57-63)
    { day: 57, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 58, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 59, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 60, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 63, type: 'race', notes: 'Half Marathon Race', distance: 13.1 },

    // Week 10 (Days 64-70)
    { day: 64, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 65, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 66, type: 'easy', notes: '8 mi run', distance: 8 },
    { day: 67, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 69, type: 'workout', notes: '8 mi pace run', distance: 8 },
    { day: 70, type: 'long', notes: '17 mi long run', distance: 17 },

    // Week 11 (Days 71-77)
    { day: 71, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 72, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 73, type: 'easy', notes: '8 mi run', distance: 8 },
    { day: 74, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 76, type: 'easy', notes: '8 mi run', distance: 8 },
    { day: 77, type: 'long', notes: '18 mi long run', distance: 18 },

    // Week 12 (Days 78-84)
    { day: 78, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 79, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 80, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 81, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 83, type: 'workout', notes: '8 mi pace run', distance: 8 },
    { day: 84, type: 'long', notes: '13 mi long run', distance: 13 },

    // Week 13 (Days 85-91)
    { day: 85, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 86, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 87, type: 'easy', notes: '8 mi run', distance: 8 },
    { day: 88, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 90, type: 'workout', notes: '5 mi pace run', distance: 5 },
    { day: 91, type: 'long', notes: '20 mi long run', distance: 20 },

    // Week 14 (Days 92-98)
    { day: 92, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 93, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 94, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 95, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 97, type: 'easy', notes: '8 mi run', distance: 8 },
    { day: 98, type: 'long', notes: '12 mi long run', distance: 12 },

    // Week 15 (Days 99-105)
    { day: 99, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 100, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 101, type: 'easy', notes: '8 mi run', distance: 8 },
    { day: 102, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 104, type: 'workout', notes: '5 mi pace run', distance: 5 },
    { day: 105, type: 'long', notes: '20 mi long run', distance: 20 },

    // Week 16 (Days 106-112)
    { day: 106, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 107, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 108, type: 'easy', notes: '6 mi run', distance: 6 },
    { day: 109, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 111, type: 'workout', notes: '4 mi pace run', distance: 4 },
    { day: 112, type: 'long', notes: '12 mi long run', distance: 12 },

    // Week 17 (Days 113-119)
    { day: 113, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 114, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 115, type: 'easy', notes: '5 mi run', distance: 5 },
    { day: 116, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 118, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 119, type: 'long', notes: '8 mi long run', distance: 8 },

    // Week 18 - Race Week (Days 120-126)
    { day: 120, type: 'cross', notes: 'Cross training', distance: 0 },
    { day: 121, type: 'easy', notes: '3 mi run', distance: 3 },
    { day: 122, type: 'easy', notes: '4 mi run', distance: 4 },
    { day: 125, type: 'easy', notes: '2 mi run', distance: 2 },
    { day: 126, type: 'race', notes: 'Marathon Race', distance: 26.2 }
  ];

  // Run types configuration
  export const runTypes = {
    easy: { 
      name: 'Easy Run', 
      color: 'bg-emerald-50 text-emerald-700 border-emerald-200' 
    },
    long: { 
      name: 'Long Run', 
      color: 'bg-blue-50 text-blue-700 border-blue-200' 
    },
    workout: { 
      name: 'Workout', 
      color: 'bg-rose-50 text-rose-700 border-rose-200' 
    },
    recovery: {
      name: 'Recovery',
      color: 'bg-slate-50 text-slate-700 border-slate-200'
    },
    cross: {
      name: 'Cross Training',
      color: 'bg-amber-50 text-amber-700 border-amber-200'
    },
    race: {
      name: 'Race',
      color: 'bg-purple-50 text-purple-700 border-purple-200'
    }
  };